<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/media",
		    "name": "Media"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>Media</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Start Subbanner -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h4 id="bnr-subheading">{{subheading}}</h4>
      </div>
    </div>
  </div>
</div>

<!-- End Subbanner -->

<!-- Media Card Start -->

<div class="container mt-4 mb-4 mediacard">

  <!-- <div class="row filtersection">

    <div class="col-lg-2 text-center"></div>

    <div class="col-lg-8 text-center">
      <div class="dropdown common">
        <select class="btn btn-secondary" [(ngModel)]="yearitem" id="dropdownMonthButton">
          <option class="text-left" *ngFor="let year of years" [value]="year.value">{{year.value}}</option>
        </select>
      </div>

      <div class="dropdown common">
        <select class="btn btn-secondary" [(ngModel)]="currqtr" id="dropdownMonthButton">
          <option class="text-left" *ngFor="let quater of quaters" [value]="quater.value">{{quater.name}}</option>
        </select>
      </div>

      <div class="common">
        <button class="btn" (click)="filterNews(currqtr, yearitem)">Search</button>
      </div>

    </div>

    <div class="col-lg-2  text-center"></div>
  </div> -->

  <!------------ CARD START ------------>
  <div class="row">

    <div *ngFor="let news of newslist" class="col-12 col-lg-6 newscard mt-35">
      <!-- filterdNews -->
      <a class="cardlink" target="{{news.link ? '_blank': null}}" href="{{news.link ? news.link: 'javascript://'}}">
        <div class="row">
          <div class="col-lg-4 col-md-4 text-center">
            <img class="newslogo" src="{{news.img}}" alt="News Logo">
          </div>
          <div class="col-lg-8 col-md-8 newscontent medianewsheading">
            <h6 *ngIf="news.link == ''" data-toggle="modal" (click)="showMediaPopup()">{{news.headline}}</h6>
            <h6 *ngIf="news.link != ''">{{news.headline}}</h6>
            <p class="newsdate"><span class="cardmonth">{{news.month}}</span> {{news.date}}, {{news.year}}</p>
            <p>{{news.description}}</p>
            <div class="readmorelink">
              <!-- <a *ngIf="news.link != ''" href="{{news.link}}" target="_blank">Read More &#8594;</a> -->
              <a *ngIf="news.link == ''" data-toggle="modal" (click)="showMediaPopup()" href="javascript:://">Read More &#8594;</a>
            </div>
          </div>
        </div>
      </a>
    </div>


    <!-- <div *ngIf="filterdNews.length == 0">
      <p>NO NEWS FOUND...</p>
    </div> -->
  </div>
  <!------------ CARD END ------------>

</div>

<div class="modal fade" id="mediaimagepopup" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog text-center" role="document">
    <!-- <div class="modal-content"> -->
    <img class="imp-bg" src="assets/images/aug05img.jpg" alt="Protectt.ai expands reach">
    <!-- </div> -->
  </div>
</div>
<!-- Media Card End -->